import { render, staticRenderFns } from "./locale-changer.vue?vue&type=template&id=54350495&scoped=true"
import script from "./locale-changer.vue?vue&type=script&lang=js"
export * from "./locale-changer.vue?vue&type=script&lang=js"
import style0 from "./locale-changer.vue?vue&type=style&index=0&id=54350495&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54350495",
  null
  
)

export default component.exports